import React, { useState, useEffect, useMemo, useRef } from "react";
import { Routes, Route, Outlet } from "react-router-dom";
import "./KeyVaultConfig.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Radio } from "antd";
import {
  addKeyvaultVal,
  getAllKeyvaultEnvConfigVal,
  updateConfigVal,
} from "../../apis/createEnvApi/createEnvApi";

import { useDispatch, useSelector } from "react-redux";
import {
  MenuItem,
  FormControl,
  Select,
  TextField,
  Modal,
  Box,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import KeyVaultConfigActions from "../../components/KeyVaultConfigActions/KeyVaultConfigActions";
import filterIcon from "../../assets/icons/filtericon.svg";
import addIcon from "../../assets/icons/addItemIcon.svg";
import Pagination from "../../components/Pagination/Pagination";
import closeIcon from "../../assets/icons/closeIcon.svg";

function KeyVaultConfig() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const EmpId = useSelector((state: any) => state.authApiSlice.Id);
  const ActiveClient = useSelector(
    (state: any) => state.clientDetails.activeClient
  );
  const [configList, setConfigList] = useState<any[]>([]);
  const [originalConfigList, setOriginalConfigList] = useState<any[]>([]);
  const [categoryList, setCategoryList] = useState([]);
  const [selectedEnv, setSelectedEnv] = useState<any>("");
  const [selectedCategory, setSelectedCategory] = useState<any>(null);
  const [rowId, setRowId] = useState(null);
  const [dataGrid, setDataGrid] = useState<any>(null);
  const filterSearchInputref = useRef<any>(null);

  const columns = [
    { field: "Code_Decode_Locale_Id", headerName: "Language" },
    { field: "Code_Code", headerName: "Key Name" },
    {
      field: "Code_Decode_Short_Desc",
      headerName: "Display Name",
    },
    { field: "Code_Decode_Long_Desc", headerName: "Description" },
  ];

  const [seletedFilterType, setSeletedFilterType] = useState<any>(columns[0]);

  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState<any>(10);

  // Get current Rows
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = configList.slice(indexOfFirstRow, indexOfLastRow);

  // Change page
  const paginate = (pageNumber: number) => setCurrentPage(pageNumber);

  const rowCountRange = [10, 25, 50, 100];

  const [openAddItemModal, setOpenAddItemModal] = useState(false);
  const handleCloseAddItemModal = () => setOpenAddItemModal(false);
  const [addItemFormInput, setAddItemFormInput] = useState<any>({});

  useEffect(() => {
    setSelectedEnv(ActiveClient.Env_Data[0]);
  }, []);

  useEffect(() => {
    if(selectedEnv)
    getAllConfig();
  }, [selectedEnv]);




  const getAllConfig = () => {
    let payload={
        "Client_Id":ActiveClient.Client_Id,
        "Env_Id":selectedEnv.Env_Id,
        "Env_Name":selectedEnv.Env_Name,
        "Client_Name":selectedEnv.Client_Name
    }
    getAllKeyvaultEnvConfigVal(payload,(resp: any) => {
      if (resp) {
        console.log("getAllKeyvaultEnvConfigVal--",resp)
        setConfigList(resp.data);
        setOriginalConfigList(resp.data);
      } else {
        navigate("/errorInvalid");
      }
    });
  };


  const handleChangeEnv = (val: any) => {
    setSelectedEnv(val);
  };


  const handleAddItemInput = (val: any, fieldName: string) => {
    let addItemFormSData: any = addItemFormInput;
    addItemFormSData[fieldName] = val;
    setAddItemFormInput(addItemFormSData);
  };
  const handleSearch = (value: any) => {
    let searchValue = value.toLowerCase();
    if (searchValue.length >= 2) {
      let cls = originalConfigList.filter((item: any) => {
        return (
          item.KeyName.toLowerCase().includes(searchValue) ||
          item.KeyValue.toLowerCase().includes(searchValue) 
        );
      });
      setConfigList(cls);
    } else {
      setConfigList(originalConfigList);
    }
  };


  const handleAddItemSubmit = (event: any) => {
    event.preventDefault();
    console.log("Add Item DATA--", addItemFormInput);

    let payload = {
      Emp_Id: EmpId,
      Client_Id: ActiveClient.Client_Id,
      Env_Id: selectedEnv.Env_Id,
      Env_Name:selectedEnv.Env_Name,
      secretName:addItemFormInput.key_name,
      secretValue:addItemFormInput.key_value,
    };
    addKeyvaultVal(payload, async (response: any) => {
      console.log("addConfigVal::--", response);
      if (response) {
        getAllConfig();
        setOpenAddItemModal(false);
      }
    });
  };

  return (
    <>
      <div className="tab-page-layout-1">
        <div className="tab-page-layout-1-header config-header-section">
          <div className="tab-page-layout-1-header-title-label">
            Configure
            <button
              className="rounded-primary-40 btn font--btn export-flow-btn config-save-btn"
              onClick={() => navigate('/keyvaultmigration')}
            >
              <div>Migrate</div>
            </button>
          </div>

          <div className="tab-header-search">
            <div className="search-box config-search-box">
              <FontAwesomeIcon
                className="search-icon"
                icon={["fas", "magnifying-glass"]}
              />

              <div className="search-input-section">
                <input
                  className="search-input"
                  type="text"
                  placeholder="Search"
                  onChange={(e) => handleSearch(e.target.value)}
                />
              </div>
            </div>
          </div>
          <div className="tab-header-env-dropdown-section">
            <div className="evn-dropdown-div pd-md">
              {ActiveClient.Env_Data.length > 1 && (
                <>
                  <div className="export-flow-title primary-color pd-md">
                    Env
                  </div>
                  <FormControl fullWidth>
                    <Select
                      labelId="select-env-label"
                      id="select-env-flow"
                      className="select-env-dropdown config-env-dropdown"
                      value={selectedEnv}
                      onChange={(e) => handleChangeEnv(e.target.value)}
                    >
                      {ActiveClient.Env_Data?.map((items: any) => {
                        return (
                          <MenuItem key={items.Env_Id} value={items}>
                            {items.Env_Name}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </>
              )}
            </div>
          </div>
          <div className="tab-header-category-dropdown-section center-div"></div>
          <div className="tab-header-right-div ">
            <div
              className="add-btn-section header-icon"
              onClick={() => setOpenAddItemModal(true)}
            >
              <img src={addIcon} className="icon-md" />
            </div>
          </div>
        </div>
        <div className="tab-page-layout-1-body">
          <div className="tab-page-layout-1-list-header keyvault-list-header">
            <div className="tab-page-layout-1-li-item  font-bold">Key Name</div>
            <div className="tab-page-layout-1-li-item  font-bold">Value</div>
            <div className="tab-page-layout-1-li-item  font-bold">Actions</div>
          </div>
          <ul
            className="tab-page-layout-1-list-section config-list-section"
            id="client-list-section"
          >
            {currentRows.map((item: any, i) => {
              return (
                <li
                  className="tab-page-layout-1-list-item-section keyvault-list-item-section"
                  key={i}
                >
                  <div className="tab-page-layout-1-li-item">
                    {item.KeyName}
                  </div>

                  <div className="tab-page-layout-1-li-item">
                    {item.KeyValue}
                  </div>
                  <div className="tab-page-layout-1-li-item">
                    <KeyVaultConfigActions
                      item={item}
                      selectedEnv={selectedEnv}
                      getAllConfig={getAllConfig}
                    />
                  </div>
                </li>
              );
            })}
          </ul>

          <div className="tab-page-layout-1-list-footer config-list-footer">
            <div className="row-count-section">
              <div className="row-count-label center-div">Show per page</div>
              <div className="row-count-dropdown-section center-div">
                <select
                  name="filter-column"
                  id=""
                  className="column-dropdown row-count-dropdown  dropdown-arrow-1"
                  onChange={(e) => setRowsPerPage(e.target.value)}
                >
                  {rowCountRange.map((item: any, i) => (
                    <option value={item} key={item}>
                      {item}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="page-number-section center-div">
              <div className="entries-count">
                {rowsPerPage * currentPage - rowsPerPage + 1} to{" "}
                {rowsPerPage * currentPage < configList.length
                  ? rowsPerPage * currentPage
                  : configList.length}{" "}
                of {configList.length} entries
              </div>
              <Pagination
                rowsPerPage={rowsPerPage}
                totalRows={configList.length}
                paginate={paginate}
                currentPage={currentPage}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Add item modal */}
      <Modal
        open={openAddItemModal}
        onClose={handleCloseAddItemModal}
        aria-labelledby="edit-modal-modal-title"
        aria-describedby="edit-modal-modal-description"
      >
        <Box className="modal-1-box">
          <div className="modal-1-header">
            <div className="modal-1-title">Add</div>
            <div
              className="modal-1-close-btn-section"
              onClick={() => {
                setOpenAddItemModal(false);
              }}
            >
              <img src={closeIcon} className="icon-md" />
            </div>
          </div>
          <form onSubmit={handleAddItemSubmit}>
            <div className="model-1-form-body">
              <div className="input-div modal-1-input-div">
                <label className="floating-label" htmlFor="client-name-input">
                  Key Name
                </label>
                <input
                  id="client-name-input"
                  className="input-field-1 "
                  required
                  type="text"
                  onChange={(e) =>
                    handleAddItemInput(e.target.value, "key_name")
                  }
                />
              </div>
              <div className="input-div modal-1-input-div">
                <label className="floating-label" htmlFor="client-name-input">
                  Key Value
                </label>
                <input
                  id="client-name-input"
                  className="input-field-1 "
                  required
                  type="text"
                  onChange={(e) =>
                    handleAddItemInput(e.target.value, "key_value")
                  }
                />
              </div>
            </div>
            <div className="model-1-form-actions center-div">
              <button
                className="rounded-primary-40 btn font--btn export-flow-btn config-cancel-btn"
                onClick={() => {
                  setOpenAddItemModal(false);
                }}
              >
                <div>Cancel</div>
              </button>
              <button
                className="rounded-primary-40 btn font--btn export-flow-btn config-save-btn"
                type="submit"
              >
                <div>Done</div>
              </button>
            </div>
          </form>
        </Box>
      </Modal>
    </>
  );
}

export default KeyVaultConfig;
